<template>
  <RevLink class="body-2" role="menuitem" :to="url" :underlined="false">
    <RevIllustration
      v-if="image"
      :alt="title"
      class="rounded-lg mb-8"
      :height="960"
      :src="image"
      :width="1280"
    />
    <span class="text-action-default-low body-1-bold">
      {{ title }}
    </span>
  </RevLink>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

defineProps<{
  url: string
  image?: string
  title: string
}>()
</script>
